import { render, staticRenderFns } from "./RequestDetails.vue?vue&type=template&id=7f5dfc03&scoped=true"
import script from "./RequestDetails.vue?vue&type=script&lang=js"
export * from "./RequestDetails.vue?vue&type=script&lang=js"
import style0 from "./RequestDetails.vue?vue&type=style&index=0&id=7f5dfc03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5dfc03",
  null
  
)

export default component.exports